import * as React from "react";
import { Divider, Modal, Table } from "antd";
import { TTranslate } from "../../../service/locale/TranslationService";
import { IPortalFormPresentationModel } from "../../../model/form/PortalFormPresentationModel";
import { IReportingPeriodApplicantDocument } from "../../../model/document/ReportingPeriodApplicantDocument";
import PortalDocumentsTable from "./PortalDocumentsTable";

const FormListModal = ({
  visible,
  onCancel,
  translate,
  forms,
  loading,
  showFormDetails,
  documents
}: {
  visible: boolean;
  onCancel: () => void;
  translate: TTranslate;
  forms: IPortalFormPresentationModel[];
  loading: boolean;
  showFormDetails: (id: number) => void;
  documents?: IReportingPeriodApplicantDocument[];
}) => {
  const columns = [
    { title: translate("portal.forms.name"), dataIndex: "name", key: "name" },
    {
      title: translate("portal.forms.publicationDate"),
      dataIndex: "publicationDate",
      key: "publicationDate"
    }
  ];
  return (
    <Modal
      okButtonProps={{ hidden: true }}
      visible={visible}
      onCancel={() => onCancel()}
      maskClosable={false}
      closable={false}
      title={translate("form_list_modal.title")}
      cancelText={translate("form_list_modal.cancel")}
    >
      <Table
        locale={{ emptyText: translate("data_grid.empty_text") }}
        pagination={{
          simple: true,
          defaultPageSize: 10,
          position: "bottom",
          hideOnSinglePage: true
        }}
        loading={loading}
        columns={columns}
        dataSource={forms}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {
              showFormDetails(record.id);
            }
          };
        }}
      />
      <Divider orientation="left">
        {translate("portal.reporting_period.documents.title")}
      </Divider>
      <PortalDocumentsTable
        translate={translate}
        documents={documents || []}
        loading={loading}
      />
    </Modal>
  );
};

export default FormListModal;
